import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: null,
  customerId: null,
  expiration: null,
  totalPrice: 0,
  totalDiscountPrice: 0,
  freight: 0,
  lines: [
    {
      code: null,
      stockId: null,
      name: null,
      num: 0,
      price: 0,
      discountPrice: 0,
      majorCategory: null,
      category: null,
      temperature: null,
    }
  ]
}

// sliceを生成
export const cart = createSlice({
  name: 'cartLine',
  initialState,
  reducers: {
    hydrate: (state, action) => {
      state = action.payload
      return {
        ...state,
      }
    },
    resetCart: () => {
      return initialState
    },
    updateCustomerId: (state, action) => {
      return {
        ...state,
        customerId: action.payload
      }
    }
  },
})

export const { hydrate, resetCart, updateCustomerId } = cart.actions
export default cart.reducer
